import React from 'react';
import './Exhibitionmodel.css';

const Exhibitionmodel = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Features of the machine</h2>
                <p className="Material-date">Highly efficient and stable:</p>
                <p className="Material-text"> short molding cycle, high output, central
                     oil cylinder structure of locking template, strong and 
                     uniform clamping force, special mold shifting 
                    reduction valve, fast and accurate positioning, no impact；
                    Each type has its own set of advantages and ideal uses in different industries.</p>
                <p className="Material-date">Intelligent:</p>
                <p className="Material-text">professionally designed blow molding machine
                     control system and PLC, modular design, flexible expansion and change,
                      central monitoring, network remote diagnosis, intelligent 
                      centralized temperature control, automatic alarm and fault feedback, highly user-friendly 
                    parameter settings, easy to master, easy to operate;</p>
                <p className="Material-date">Fast color change:</p>
                <p className="Material-text">unique screw parameter design, combined with precise temperature 
                    and speed control, plasticization and mixing to achieve the best results,
                     uniform and bright color, deep mirror treatment inside the die, 
                     smooth curved flow path, no dead ends, No carbon deposit, uniform and 
                    dense extruded rubber embryo thickness, fast color change.</p>
                      <h2 className="Material-title">Application</h2>
                <p className="Material-text"> Mainly produce PETG thick-bottom bottles,
                     double-layer high-gloss bottles,
                     and high-end cosmetic bottles for color cosmetics.</p>
            </div>
        </div>
    );
};
export default Exhibitionmodel;
